import { useQuery } from '@tanstack/react-query'
import { formatISO } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { getNextReservationEvents } from 'services/reservation/getNextReservationEvents'

interface UseGetNextReservationEvents {
  nextReservationEventsData: string[]
  isLoading: boolean
}

function handleFormatReservationEvents(events: string[]): string[] {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const formattedEventsToDateObject = events.map(event => new Date(event))
  const formattedToDateZone = formattedEventsToDateObject.map(event => utcToZonedTime(event, timeZone))
  const formattedToIso = formattedToDateZone.map(event => formatISO(event))

  return formattedToIso
}

export const useGetNextReservationEvents = (reservationUUID: string): UseGetNextReservationEvents => {
  const { data, isSuccess, isLoading } = useQuery({
    queryKey: ['GET_NEXT_RESERVATION_EVENTS', reservationUUID],
    queryFn: () => getNextReservationEvents(reservationUUID),
    enabled: !!reservationUUID,
    cacheTime: 0
  })

  if (isSuccess) {
    const formattedEvents = handleFormatReservationEvents(data.next_dates)

    return {
      nextReservationEventsData: formattedEvents,
      isLoading
    }
  }
  
  return {
    nextReservationEventsData: [],
    isLoading
  }
}